import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook to fetch dynamic lanes (Three Lanes) from the backend
 */
const useLanes = () => {
  const [lanes, setLanes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLanes = async () => {
      try {
        const response = await fetch(`${API_URL}/api/lanes`, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setLanes(data);
        } else {
          console.error('Failed to fetch lanes');
          setError('Failed to fetch lanes');
        }
      } catch (err) {
        console.error('Error fetching lanes:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLanes();
  }, []);

  return { lanes, loading, error };
};

export default useLanes;
